import React, { FC } from 'react';
import { CommentariesRestrictedModal } from './public/CommentariesRestrictedModal';
import { ExpiredRestrictedModal } from './expired/ExpiredRestrictedModal';
import { useUser } from '../../../../user/useUser';

type Props = {
  source: string;
  isOpen?: boolean;
  onRequestClose?: () => void;
};

export const RestrictedModalCommentaries: FC<Props> = ({
  source,
  isOpen = false,
  onRequestClose = () => {},
}) => {
  const { loggedIn } = useUser();

  if (loggedIn) {
    return (
      <ExpiredRestrictedModal
        source={source}
        closeModal={onRequestClose}
        isOpen={isOpen}
      />
    );
  }

  return (
    <CommentariesRestrictedModal
      source={source}
      closeModal={onRequestClose}
      isOpen={isOpen}
    />
  );
};
